__turbopack_context__.v({
  "actions": "CompareBar-module-scss-module__zX3MxW__actions",
  "bar": "CompareBar-module-scss-module__zX3MxW__bar",
  "clearAll": "CompareBar-module-scss-module__zX3MxW__clearAll",
  "compareButton": "CompareBar-module-scss-module__zX3MxW__compareButton",
  "open": "CompareBar-module-scss-module__zX3MxW__open",
  "placeholder": "CompareBar-module-scss-module__zX3MxW__placeholder",
  "productList": "CompareBar-module-scss-module__zX3MxW__productList",
  "title": "CompareBar-module-scss-module__zX3MxW__title",
  "titleLong": "CompareBar-module-scss-module__zX3MxW__titleLong",
  "titleRow": "CompareBar-module-scss-module__zX3MxW__titleRow",
  "titleShort": "CompareBar-module-scss-module__zX3MxW__titleShort",
});
